module.exports = __webpack_public_path__ + "img/card-1.a05b4bc1.png";